module.exports = __webpack_public_path__ + "goura--81543745.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/goura.jpg
// module id = 164
// module chunks = 0